import Vue from 'vue'

// 验证是否为blob格式
export async function blobValidate(data) {
	console.log('data: ', data);
	try {
		const text = await data.text();
		JSON.parse(text);
		return false;
	} catch (error) {
		return true;
	}
}

// JS数组分组每size个元素
export function chunkArray(arr, size) {
	return arr.reduce((resultArray, item, index) => {
		const chunkIndex = Math.floor(index / size);

		if (!resultArray[chunkIndex]) {
			resultArray[chunkIndex] = []; // 创建一个新的子数组
		}

		resultArray[chunkIndex].push(item);

		return resultArray;
	}, []);
}

// 
export function filterByKey(key, value, args, valueName) {
  console.log(args)
  if (args.length) {
    let obj = args.find(item => item[key] == value)
    if (obj) {
      return obj[valueName]
    } else {
      return ''
    }
  } else {
    return ''
  }

}